<template>
    <b-modal ref="profile_modal"
             size="lg"
             bodyClass="p-0"
             v-bind:no-close-on-backdrop=true
             :hide-header=true
             v-model="is_show_modal"
             :dialogClass=dialog_class_draw>

        <template v-slot:modal-header="{ close }">
            <!-- Emulate built in modal header close button action -->
            <b-button size="sm" variant="outline-danger" @click="close()">
                Close Modal
            </b-button>
        </template>

        <!-- BODY -->
        <div id="panel_user_list" class="panel mb-0 border-bottom-0 shadow-none">
            <div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
                <h2 >
                    <span class="fw-300">ID:{{this.item.uniq_id}}</span>
                </h2>
                <div class="panel-toolbar pr-3 pb-2 align-self-end">
                    <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
            </div>

            <div class="panel-container show">

                <b-overlay :show="is_load" rounded="sm">

                    <div class="panel-content">
                        <div class="d-flex flex-column align-items-center justify-content-center p-4">
                            <h5 class="mb-0 fw-700 text-center mt-3">
                                {{this.item.title}}
                                <small class="text-muted mb-0">
                                    {{__t('MODIF_INFO')}}
                                </small>
                            </h5>
                        </div>

                        <div>
                            <b-tabs content-class="mt-3">
                                <b-tab v-for="(tab,index) in tabs" @click="set_active(index)"
                                       :disabled="tab.disabled"
                                       :title="get_tab_title(tab)"
                                       :key="index"
                                       :active="tab.is_active"
                                >
                                    <template slot="title">
                                        {{get_tab_title(tab)}}
                                        <b-spinner type="grow" small v-if="tab.is_load"></b-spinner>
                                    </template>

                                    <component v-bind:is="tab.index" :modif="item"></component>

                                    <div v-if="tab.html !=''">
                                        {{tab.html}}
                                    </div>
                                </b-tab>
                            </b-tabs>
                        </div>
                        <div>
                        </div>
                    </div>

                </b-overlay>
            </div>
            <!--FOOTER -->
        </div>

        <template v-slot:modal-footer="{close}">
            <div class="modal-footer">
                <button type="button" @click="remove(false)" class="btn btn-outline-danger waves-effect waves-themed mr-5 pl-5 pr-5" v-if="item_id > 0">
                    {{ __t('REMOVE') }}
                </button>


                <button type="button" @click="close()" class="btn btn-secondary waves-effect waves-themed">
                    {{ __t('CLOSE') }}
                </button>

                <button type="button" v-on:click="save_item" class="btn btn-primary waves-effect waves-themed">
                    {{ __t('SAVE') }}
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script>
    import m_info from "./tabs/m_info.vue";
    import m_products from "./tabs/m_products.vue"
    import m_translate from "./tabs/m_translate.vue";
    export default {
        components : {
            m_info,
            m_products,
            m_translate
            /* city_settings,
             city_info*/
        },
        name: "modif_modal",
        props : {
            modal_position : {
                type : String,
                default : "right"
            },
        },
        data() {
            return {
                item_id : 0,
                item: {
                    "id" : 0,
                    "name" : "",
                    "uniq_id" : "",
                    "price" : 0,
                    'group_id' : 0,
                    'published' : 1,
                    'is_product' : 0,

                },
                is_load: false,
                is_show_modal: false,
                tabs : []
            }
        },

        created () {
            EventBus.$on("modifier_edit",res => this.work_click(res));
            EventBus.$on("close_modif",this.close);
        },

        methods : {

            work_click(_id) {
                this.item_id = _id;
                this.is_show_modal = true;
                this.load_group();
            },

            get_tab_title (tab) {
                if(tab.count > 0) {
                    return tab.title;
                }
                return tab.title;
            },

            set_active (obj) {
                for (let tab in this.tabs) {
                    this.tabs[tab].is_active = false;
                }

                this.tabs[obj].is_active = true;
                EventBus.$emit('update:tabu', {type: this.tabs[obj].index, user_id: this.user_id});
            },

            async remove(is_force) {
                let self = this;
                const is_ok = confirm_me(this.__t("ARE_SURE"));
                is_ok.then(res => {
                    self.is_load = true;
                    api.delete('/internal/v1/catalog/modifiers/'+ parseInt(this.item.id)).then(({data}) => {
                        self.is_load = false;
                        if (data.status === "operation_success") {
                            window.location.reload();
                        }
                    }).catch(({response}) => {
                        self.is_load = false;
                        EventBus.$emit('show_toast', {
                            err: response.data.message, type: "danger",
                            title: response.data.status,
                            position : "b-toaster-top-left"
                        })
                    });
                });
            },

            async save_item() {
                this.is_load = true;
                await api.put('/internal/v1/catalog/modifiers/'+ parseInt(this.item.id),this.item)
                    .then(({data}) => {
                        this.is_load = false;
                        if (data.status === "operation_success") {
                            EventBus.$emit('save_translation',data.data.id,'modifier', this.Onclose);
                        }
                    }).catch(({response}) => {
                        this.is_load = false;
                        EventBus.$emit('show_toast', {
                            err: response.data.message,
                            type: "danger",
                            title: response.data.status,
                            position : "b-toaster-top-left",
                        })
                    });
            },

            Onclose() {
                EventBus.$emit("close_modif");
                EventBus.$emit("reload_modifiers");
            },


            close () {
                this.item = {
                    "id" : 0,
                    "name" : "",
                    "uniq_id" : "",
                    "price" : 0,
                    'group_id' : 0,
                    'published' : 1,
                    'is_product' : 0,
                };

                this.tabs = [];
                this.is_show_modal = false;
            },

            async load_group () {
                this.is_load = true;
                this.tabs = [];
                await api.get('/internal/v1/catalog/modifiers/' + parseInt(this.item_id)).then(({data}) => {
                    this.is_load = false;
                    if (data.status === "operation_success") {
                        this.item = data.data;
                        this.push_tabs();
                    }
                }).catch(({response}) => {
                    this.is_load = false;
                    EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status,position : "b-toaster-top-left"})
                });
            },

            push_tabs() {
                this.default_tabs.map(item => {
                    this.tabs.push({
                        title: item.title,
                        disabled: false,
                        is_active: false,
                        is_load: false,
                        index: item.index,
                        html: ''
                    });
                });
            },
        },

        computed : {
            default_tabs() {
                return [
                    {
                        "title": this.__t('MAIN_SETTINGS'),
                        "index": "m_info",
                        is_active:true,
                    },
                    {
                        "title": this.__t('PRODUCTS'),
                        "index": "m_products",
                        is_active:false,
                    },
                    {
                        "title": this.__t('TRANSLATES'),
                        "index": "m_translate",
                        is_active:false,
                    },

                ];
            },


            dialog_class_draw () {
                if(this.modal_position === "left") {
                    return "modal-dialog-left modal-lg";
                }

                return "modal-dialog-right modal-lg";
            },
        }
    }
</script>

<style scoped>

</style>
